// اضافه کردن کتابخانه ها به صفحه
import * as React from "react";
import {FormControl, FormControlLabel, MenuItem, Select, Switch} from "@mui/material";
import styled from "@emotion/styled";
import {SaveOutlined} from "@mui/icons-material";
import {ThemeContext} from "../../App";
import {useTranslation} from "react-i18next";

// ایمپورت کردن کامپوننت ها در داخل صفحه
import NavBar from "../../components/NavBar";
import {ReactComponent as Message} from './../../assets/img/icons/setting/message.svg';
import {ReactComponent as Print} from './../../assets/img/icons/setting/print.svg';
import {ReactComponent as Box} from './../../assets/img/icons/setting/box.svg';
import {ReactComponent as UploadIcon} from './../../assets/img/icons/setting/uploadIcon.svg';
import {ReactComponent as Theme} from './../../assets/img/icons/setting/theme.svg';
import {ReactComponent as Translate} from './../../assets/img/icons/setting/translate.svg';

// استایل های سفارشی برای سوئیچ اکشن ها
const IOSSwitch = styled((props) => (
   <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 42,
  height: 26,
  padding: 0,
  '& .MuiSwitch-switchBase': {
    padding: 0,
    margin: 2,
    transitionDuration: '300ms',
    '&.Mui-checked': {
      transform: 'translateX(16px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        background: '#F7941D',
        opacity: 1,
        border: 0,
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        opacity: 0.5,
      },
    },
    '&.Mui-focusVisible .MuiSwitch-thumb': {
      color: '#F7941D',
      border: '6px solid #fff',
    },
    '&.Mui-disabled .MuiSwitch-thumb': {
      color: '#A8A8A8'
    },
    '&.Mui-disabled + .MuiSwitch-track': {
      opacity: 0.7,
    },
  },
  '& .MuiSwitch-thumb': {
    boxSizing: 'border-box',
    width: 22,
    height: 22,
  },
  '& .MuiSwitch-track': {
    borderRadius: 26 / 2,
    background:'#E9E9EA',
    opacity: 1,

  },
}));

export default function Setting() {
  // استفاده از متود های i18n برای چند زبان کردن پروژه و تغییر زبان پروژه
  const {t, i18n} = useTranslation()
  // گرفتن متغیر گلوبال از طریق useContext
  const theme = React.useContext(ThemeContext)
  // متغیر و useState های لوکال صفحه
  const [language, setLanguage] = React.useState(i18n.language);

  // متد تغییر زبان پروژه و اضافه کردن زبان فعلی پروژه به متغیرهای لوکال صفحه
  const handleChangeLang = (event) => {
    i18n.changeLanguage(event.target.value);
    setLanguage(event.target.value);
  };


  // متد تغییر تم وب سایت
  const changeSwitch = (e) => {
    theme.toggleTheme(e.target.checked)
  }


  return (
     <>
       {/*کامپوننت نوبار*/}
       <div className="d-block d-lg-none">
         <NavBar blue back/>
       </div>

       <div className="container">
         <div className="settingPage desktopSection">
           <h4 className="titleSection">{t("dashboard.setting.t1")}</h4>

           <div className="item">
             <div>
               <Message/>
               <span>{t("dashboard.setting.t2")}</span>
             </div>
             <FormControlLabel
                control={<IOSSwitch sx={{ m: 1 }} defaultChecked />}
             />
           </div>
           <div className="item">
             <div>
               <Print/>
               <span>{t("dashboard.setting.t3")}</span>
             </div>
             <FormControlLabel
                control={<IOSSwitch sx={{ m: 1 }} defaultChecked />}
             />
           </div>
           <div className="item">
             <div>
               <Box/>
               <span>{t("dashboard.setting.t4")}</span>
             </div>
             <FormControlLabel
                control={<IOSSwitch sx={{ m: 1 }} defaultChecked />}
             />
           </div>
           <div className="item">
             <div>
               <UploadIcon/>
               <span>{t("dashboard.setting.t5")}</span>
             </div>
             <FormControlLabel
                control={<IOSSwitch sx={{ m: 1 }} defaultChecked />}
             />
           </div>

           <div className="item">
             <div>
               <Theme/>
               <span>{t("dashboard.setting.t6")}</span>
             </div>
             <FormControlLabel
                id="darkMode"
                onChange={(e) => changeSwitch(e)}
                control={<IOSSwitch sx={{ m: 1 }} defaultChecked  checked={theme.darkMode}/>}
             />
           </div>
           <div className="item">
             <div>
               <Translate/>
               <span>{t("dashboard.setting.t7")}</span>
             </div>
             <div className="lang">
               <FormControl>
                 <Select
                    id="language"
                    value={language}
                    name="language"
                    onChange={handleChangeLang}
                    inputProps={{'aria-label': 'Without label'}}
                 >
                   <MenuItem value="fa">فا</MenuItem>
                   <MenuItem value="en">En</MenuItem>
                 </Select>
               </FormControl>
             </div>
           </div>

           {/*دکمه ثبت تغییر تنظیمات وب سایت*/}
           <div className="_btnGroup_yellow">
             <button className="btnFill">
               <span>{t("dashboard.setting.t8")}</span>
               <SaveOutlined fontSize="large"/>
             </button>
           </div>
         </div>
       </div>
     </>
  )
}
